define('AAMedical.ScopeRepair.FlexibleScopeRepair.View'
,	[
		'aamedical_scoperepair_flexible.tpl',
		'Utils'
	]
,	function (
		aamedical_scoperepair_flexible_tpl,
		Utils
	)
{
	'use strict';

	return Backbone.View.extend({

		template: aamedical_scoperepair_flexible_tpl,

		title: Utils.translate('Flexible Scope Repair'),

		page_header: Utils.translate('Flexible Scope Repair'),

		attributes: {
			id: 'flexible-scope-repair',
			class: 'flexible-scope-repair-page'
		},

		getBreadcrumbPages: function() {
			return [{ href: '/flexible-scope-repair', text: Utils.translate('Flexible Scope Repair') }];
		},

		getContext: function() {
			return {};
		}
	});
});
